import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import { BrowserRouter, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import React from 'react';
import ReactDOM from 'react-dom';
import App from 'components/app.component';
import { getQueryClient } from 'features/config/config';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import store from 'store/store';
import { AppInsightsContextProvider } from 'features/app-insights/app-insights-context';

ReactDOM.render(
    <QueryClientProvider client={getQueryClient()}>
        <Provider store={store}>
            <BrowserRouter>
                <AppInsightsContextProvider>
                    <Route path="*" component={App} />
                </AppInsightsContextProvider>
            </BrowserRouter>
        </Provider>
        <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>,
    document.getElementById('root'),
);
